<template>
    <div class="testimonialsSlider__sliderContainer" v-cloak>
        <Splide class="testimonialsSlider__slider" :options="options">
            <SplideSlide class="testimonialsSlider__slide slide" v-for="(slide, i) in slides" :key="i">
                <blockquote class="testimonialsSlider__blockquote">
                    <div class="testimonialsSlider__blockquoteText">
                        <img v-if="theme.length > 0"
                             :src="`${theme}/images/quote.png`"
                             alt="left quote mark"
                             height="62"
                             width="93"
                             class="testimonialsSlider__blockquoteTextQuote testimonialsSlider__blockquoteTextQuote--left"
                             draggable="false"
                             loading="lazy"
                        />

                        <p class="testimonialsSlider__blockquoteTextText"
                           v-html="slide.quote"
                        />

                        <img v-if="theme.length > 0"
                             :src="`${theme}/images/quote.png`"
                             alt="right quote mark"
                             height="62"
                             width="93"
                             class="testimonialsSlider__blockquoteTextQuote testimonialsSlider__blockquoteTextQuote--right"
                             draggable="false"
                             loading="lazy"
                        />
                    </div>

                    <p v-if="slide.handwritten_subquote"
                       class="testimonialsSlider__blockquoteHandwritten"
                       :class="[slide.handwritten_subquote_colour ? `testimonialsSlider__blockquoteHandwritten--${slide.handwritten_subquote_colour}` : '',]"
                       v-html="slide.handwritten_subquote"
                    />

                    <cite class="testimonialsSlider__blockquoteCite">
                        <span v-html="slide.citation_line_one" />

                        <span v-if="slide.citation_line_two"
                              v-html="slide.citation_line_two"
                        />
                    </cite>
                </blockquote>
            </SplideSlide>
        </Splide>
    </div> <!-- .sliderWrap -->
</template>

<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide'
import { defineComponent, defineProps } from 'vue'

export default defineComponent({
    props: {
        slides: {
            type: Object,
        },
        options: {
            type: Object,
        },
        theme: {
            type: String,
            default: ""
        }
    },
    components: {
        Splide,
        SplideSlide,
    },
});
</script>
